export default class MarketPlace {
    constructor(appName) {
        this.appName = appName;
        this.games =
            [
                {
                    name: "Spades",
                    FBInstant: "1076879022772932",
                    ios: "itms-apps://itunes.apple.com/app/id6458878117",
                    android: "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.spades",
                    windows: "https://cardsjd.com/spades",
                    web: "https://cardsjd.com/spades",
                },
                {
                    name: "GinRummy",
                    FBInstant: "1150157359290701",
                    ios: "itms-apps://itunes.apple.com/app/id6470861992",
                    android: "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.ginrummy",
                    windows: "https://cardsjd.com/ginrummy",
                    web: "https://cardsjd.com/ginrummy",
                },
                {
                    name: "Cribbage",
                    FBInstant: "1264960130273679",
                    ios: "itms-apps://itunes.apple.com/app/id1362318446",
                    android: "https://play.google.com/store/apps/details?id=com.jdsoftwarellc.cribbage",
                    windows: "https://cardsjd.com/cribbage",
                    web: "https://cardsjd.com/cribbage",
                    amazon: "amzn://apps/android?asin=B07BMRYW6D"
                },
                {
                    name: "Speed",
                    FBInstant: "401658098090396",
                    ios: "itms-apps://itunes.apple.com/app/id914247866",
                    android: "https://play.google.com/store/apps/details?id=com.jimmyinteractive.speed",
                    windows: "https://cardsjd.com/speed",
                    web: "https://cardsjd.com/speed",
                },
                {
                    name: "Nertz",
                    FBInstant: "",
                    ios: "itms-apps://itunes.apple.com/app/id1089058813",
                    android: "https://play.google.com/store/apps/details?id=com.jimmyinteractive.nertz",
                    windows: "https://cardsjd.com/nertz",
                    web: "https://cardsjd.com/nertz",
                },
                {
                    name: "Solitaire",
                    FBInstant: "",
                    ios: "itms-apps://itunes.apple.com/app/id1042411982",
                    android: "https://play.google.com/store/apps/details?id=com.jimmyinteractive.solitaire",
                    windows: "https://cardsjd.com/solitaire",
                    web: "https://cardsjd.com/solitaire",
                },
                {
                    name: "Minesweeper",
                    FBInstant: "",
                    ios: "https://itunes.apple.com/us/app/minesweeper-classic-mine-sweeper/id1163024893?mt=8",
                    android: "https://play.google.com/store/apps/details?id=com.jimmyinteractive.minesweeper",
                    windows: "https://cardsjd.com/minesweeper/",
                    web: "https://cardsjd.com/minesweeper/",
                },
            ];

    }

    hasGames(osOverride) {
        const hasGame = this.getGames(osOverride).length > 0;
        return hasGame;
    }
    getGames(osOverride) {
        let os = osOverride || this.getOS();
        const games = this.games.filter(game => { return game[os] && game.name !== this.appName });
        return games;
    }
    async switchGameAsync(id) {
		if (typeof FBInstant == "undefined") return Promise.resolve(false);
		return FBInstant.switchGameAsync(id);
	}
    show(appName, osOverride) {
        let os = osOverride || this.getOS();
        const games = this.games.filter(game => { return game[os] && game.name === appName });
        if (games.length > 0) {
            const game = games[0];
            if (os === "FBInstant") {
                this.switchGameAsync(game.FBInstant).catch(function (e) {
                    console.log("fBInstantGame.switchGameAsync: Error: " + JSON.stringify(e));// Handle game change failure
                });
            } else {
                window.open(game[os], "_system");
            }
        }
    }
    getOS() {
        let os = null;

        var ua = navigator.userAgent;
        var isKindle = /Kindle|Silk|Amazon|KFDOWI|KFAPWA|KFSAW|KFGIWI|KFGIWI|KFAPW|KFARWI|KFTBWI|KFASWI|KFFOWI|KFJW|KFMEWI|KFOT|KFS‌​AW|KFSOWI|KFTBW|KFTH‌​W|KFTT|WFFOWI|KFJWA|KFJWI|KFTHWA|KFTHWI|KFAPWI|KFKAWI/i.test(ua);

        if (typeof FBInstant !== "undefined") {
            os = "FBInstant";
            if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
                os = "FBInstantiOS"; //used to not show more games on fb ios
            }
            return os;
        }
        if (/(android)/i.test(navigator.userAgent) && isKindle) {
            os = "amazon";
        }
        else if (/(android)/i.test(navigator.userAgent) && !isKindle) {
            os = "android";
        }
        else if (/(ipod|iphone|ipad)/i.test(navigator.userAgent) || navigator.platform === 'MacIntel') {
            os = "ios";
        }
        else if (/(windows phone)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        else if (/(windows)/i.test(navigator.userAgent)) {
            os = "windows";
        }
        return os;
    }
}